if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        const nextButton = event.target.closest('.product-media-modal__arrow--next');
        const prevButton = event.target.closest('.product-media-modal__arrow--prev');

        if (nextButton) {
          event.preventDefault();
          event.stopPropagation();
          this.showNext();
        } else if (prevButton) {
          event.preventDefault();
          event.stopPropagation();
          this.showPrevious();
        }
      });

      this.addEventListener('keydown', (event) => {
        if (event.code === 'ArrowRight') this.showNext();
        if (event.code === 'ArrowLeft') this.showPrevious();
      });
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    getMediaItems() {
      return Array.from(this.querySelectorAll('[data-media-id]'));
    }

    showMedia(mediaId) {
      if (!mediaId) return;

      this.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
      });

      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();

      this.currentMediaId = mediaId;
    }

    showNext() {
      const items = this.getMediaItems();
      if (items.length === 0) return;
      const currentIndex = items.findIndex((el) => el.getAttribute('data-media-id') === this.currentMediaId);
      const nextIndex = (currentIndex + 1 + items.length) % items.length;
      this.showMedia(items[nextIndex].getAttribute('data-media-id'));
    }

    showPrevious() {
      const items = this.getMediaItems();
      if (items.length === 0) return;
      const currentIndex = items.findIndex((el) => el.getAttribute('data-media-id') === this.currentMediaId);
      const prevIndex = (currentIndex - 1 + items.length) % items.length;
      this.showMedia(items[prevIndex].getAttribute('data-media-id'));
    }

    showActiveMedia() {
      const mediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
      this.showMedia(mediaId);
    }
  });
}

if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    loadContent() {
      super.loadContent();

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  });
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => { 
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});